import Alert from 'antd/lib/alert';
import LoadingOutlined from '@ant-design/icons/lib/icons/LoadingOutlined';
import WarningOutlined from '@ant-design/icons/lib/icons/WarningOutlined';
import { BillProcessingStatus } from 'src/domain/customer-utility-bill/interface';

export const BillExtractionStatusAlert = ({ status }: { status: BillProcessingStatus }) => {
    if (status === BillProcessingStatus.DownloadFailed) {
        return (
            <Alert
                type="error"
                showIcon
                icon={<WarningOutlined />}
                message="Bill couldn’t be processed — extracted fields may be empty."
                style={{ marginBottom: 10 }}
            />
        );
    }
    if (status === BillProcessingStatus.Pending) {
        return <Alert type="info" showIcon icon={<LoadingOutlined />} message="Waiting to start extraction…" style={{ marginBottom: 10 }} />;
    }
    if (status === BillProcessingStatus.ParsingInProgress) {
        return <Alert type="info" showIcon icon={<LoadingOutlined />} message="AI extraction in progress…" style={{ marginBottom: 10 }} />;
    }
    return null;
};
